import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {axiosInstance} from '../services/Api';

// Async thunks for stocks and article movements
export const fetchStocks = createAsyncThunk(
  "sales/filtredStock",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/sales/filtredStock", filters);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "An error occurred");
    }
  }
);

export const fetchArticleMovements = createAsyncThunk(
  "sales/filtredArticleMovements",
  async (filters, { rejectWithValue }) => {
    try {
      
      const response = await axiosInstance.post("/sales/mouvementStock", filters);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "An error occurred");
    }
  }
);

// Sales slice for stocks and article movements
const stockSlice = createSlice({
  name: "Stock",
  initialState: {
    Stocks: [],
    loading: false,
    error: null,
    message: null,
    selectedStock: null, 
    pagination: {},
    articleMovements: [], // Stores article movements data
    articlePagination: {}, // Stores pagination data for article movements
  },
  reducers: {
    clearAlerts: (state) => {
      state.message = null;
    },
    setSelectedStock: (state, action) => {
      state.selectedStock = action.payload; 
    },
    clearSelecteStock: (state) => {
      state.selectedStock = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStocks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStocks.fulfilled, (state, action) => {
        state.loading = false;
        state.Stocks = action.payload.stock;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchStocks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Handle article movements fetch
      .addCase(fetchArticleMovements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchArticleMovements.fulfilled, (state, action) => {
        state.loading = false;
        state.articleMovements = action.payload.data; // Assign the article movements data
        state.articlePagination = action.payload.pagination; // Pagination info for article movements
      })
      .addCase(fetchArticleMovements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions
export const { clearAlerts, setSelectedStock, clearSelecteStock } = stockSlice.actions;

// Export the reducer
export default stockSlice.reducer;
